module.exports = __webpack_public_path__ + "media/images/pdf/logo_phillife_dark-4e0d0adf04dc665ee77128b05c50e6fc.png";